<template>
  <v-main class="px-0 mx-1">
    <v-container fluid class="pa-0">
      <v-row justify="center" align="center" class="pt-3">
        <v-col md="12" lg="10" sm="11" xs="12" class="pt-3">
          <ChatHeader />
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="pa-0">
      <v-row
        justify="center"
        align="center"
        class="pb-3"
        v-if="!roomActive"
        :class="this.$vuetify.theme.dark == true?'black':''"
      >
      

        <v-col md="12" lg="10" sm="12" xs="12" class="pt-0" v-if="roomListe.length>0">
          <v-container fluid class="pa-0 py-0 my-0">
            <v-row align="center" justify="center" class="py-0 my-0">
              <v-col cols="12" md="12" lg="12" sm="12" class="py-0 my-0">
                <v-row class="py-0 my-0">
                  <v-col
                    md="3"
                    lg="3"
                    sm="4"
                    xs="6"
                    cols="12"
                    style="text-align:center"
                    class="px-2"
                    v-for="(item,i) in roomListe"
                    :key="i"
                  >
                    <ChatRoomCard :roomData="item"></ChatRoomCard>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col v-else-if="loader ==false && roomListe.length == 0" md="12" lg="12" sm="12" cols="12" class="text-center">
          <v-img
            :src="require('@/assets/img/svg/DataNotFound.svg')"
            :lazy-src="require('@/assets/img/svg/DataNotFound.svg')"
            width="15%"
            style="border-radius:8px;margin-left:auto;margin-right:auto"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <h2 class="google-font" @click="debug()">Fehler beim Laden der Chaträume</h2>
          </v-col>
        <v-col v-if="loader" md="12" lg="10" xs="12" class="pt-3">
          <v-container fluid class>
            <v-row>
              <v-col md="2" lg="2" sm="3" cols="6" v-for="i in 5" :key="i">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class>
                  <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        align="center"
        class="pb-3"
        v-else
        :class="this.$vuetify.theme.dark == true?'black':''"
      >
      <v-col md="11" sm="11" lg="11" xs="12" class="py-0" :class="this.$vuetify.theme.dark == true?'darkModeContainer':'lightModeContainer'">
       
      <ChatRoom :roomData="room"></ChatRoom>
      </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
//import service from "@/services/appservices";
import * as socket from "@/plugins/socketio.js";
import { mapState, mapGetters } from "vuex";
import { APIService } from "@/assets/constants/config.js";
const apiService = new APIService();
export default {
  name: "Chat",
  inject: ["theme"],
  components: {
    ChatHeader: () => import("@/components/chat/ChatHeader"),
    ChatRoomCard: () => import("@/components/chat/ChatRoomCard"),
    ChatRoom: () => import("@/components/chat/ChatRoom")
  },
  data: () => ({
    loader: true,
    ErrorMsg: "",
    noData: false,
    socketInit: false,
    roomListe: [],
    room: {},
    roomActive: false,
    userListe: [],
    messages: []
  }),
  mounted(){
      if(!socket.status()){
        
socket.initSocket(this.currentUser.userHash);
    
      }
      socket.initSocketEvents(this);
    this.socketInit = true;
    var setUserEvent = {
      type: 'GetStatus',
      data: {
        hash: this.currentUser.userHash
      }
    }
    socket.sendEvent(setUserEvent);
    
    this.loader = false;
    
  },
  computed: {
    ...mapState(["config", "currentUser"]),
    ...mapGetters({
      currentUser: "currentUser",
    }),
  },
  methods: {
    update(room){
       this.room = room;
    },
    loadRooms(){
      this.getRooms();
    },
    getRooms(){
this.loader = true
          apiService.getChatRooms(this.currentUser.userHash).then(res=>{
            if(res.status==200){
              this.roomListe = res.data
              this.loader = false
              this.notFound = false
            }else{
              this.notFound = true
              this.loader = false
            }
          }).catch(e=>{
            this.loader = false
            this.notFound = true
            this.ErrorMsg = e
          })
    },
    scrollToEnd() {
        var container = this.$el.querySelector("#chatbox");
        if(container){
          container.scrollTop = container.scrollHeight;
        }
      
      
    },
    goToRoom(room){
      this.room = room;
      this.roomActive = true;
          },
          leaveRoom(){
this.room = {};
this.roomActive = false;
          },
    setRoomListe(liste){
      liste.roomListe.forEach(element => {
        this.roomListe.push(element)
        element.users.forEach(user => {
        if(user.hash == this.currentUser.userHash){
          this.room = element;
          this.roomActive = true;
        }
      });
      });
    },
  }
};
</script>

<style scoped>
@media screen and (min-width: 600px) {
  .card-top-margin {
    margin-top: -110px;
  }
  .bottom-space {
    margin-bottom: 80px;
    margin-top: 20px;
  }
}
@media screen and (max-width: 600px) {
  .card-top-margin {
    margin-top: -100px;
  }
  .bottom-space {
    margin-bottom: 50px;
  }
}
</style>